import {
  Box,
  Group,
  Skeleton,
  Stack,
  Text,
  useMantineTheme,
} from "@mantine/core";
import { IconChevronLeft } from "@tabler/icons-react";
import React from "react";

type Props = {
  count: number;
};
function ListItemLoading({ count }: Props) {
  const theme = useMantineTheme();
  return (
    <Stack p="md">
      {Array.from(Array(count), (_, i) => (
        <React.Fragment key={i}>
          <Group
            styles={{
              root: {
                borderBottom: `1px solid ${theme.colors.gray[3]}`,
              },
            }}
            key={i}
            justify="space-between"
            pb="md"
            wrap="nowrap"
          >
            <Stack gap="0">
              <Text size="sm">
                <Skeleton w="50%" height={5} />
              </Text>
              <Box w="200" mt="xs">
                <Text size="xs" c={theme.colors.gray[6]} truncate="end">
                  <Skeleton w="70%" height={5} />
                </Text>
              </Box>
            </Stack>
            <IconChevronLeft size="0.9rem" color={theme.colors.gray[5]} />
          </Group>
        </React.Fragment>
      ))}
    </Stack>
  );
}

export default ListItemLoading;
